import type { CustomizableMetric } from 'venn-utils';

export type OptionsPerformanceSummaryBlockMetricKeys = (typeof OPTIONS_PERFORMANCE_SUMMARY_METRICS)[number]['key'];

export const OPTIONS_PERFORMANCE_SUMMARY_METRICS = [
  {
    key: 'symbol',
    metricPath: 'symbol',
    label: 'Ticker',
    dataType: 'TEXT',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Reference Data',
  },
  {
    key: 'optionType',
    metricPath: 'optionType',
    label: 'Call/Put',
    dataType: 'TEXT',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Reference Data',
  },
  {
    key: 'strike',
    metricPath: 'strike',
    label: 'Strike Price',
    dataType: 'CURRENCY',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Reference Data',
  },
  {
    key: 'expiration',
    metricPath: 'expiration',
    label: 'Expiration Date',
    dataType: 'TEXT',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Reference Data',
  },
  {
    key: 'exerciseStyle',
    metricPath: 'exerciseStyle',
    label: 'Exercise Style',
    dataType: 'TEXT',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Reference Data',
  },
  {
    key: 'impliedVolatility',
    metricPath: 'impliedVolatility',
    label: 'Implied Volatility',
    dataType: 'PERCENTAGE',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'underlyingSpotPrice',
    metricPath: 'underlyingSpotPrice',
    label: 'Underlying Spot Price',
    dataType: 'CURRENCY',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'currentOptionPrice',
    metricPath: 'currentOptionPrice',
    label: 'Current Option Price',
    dataType: 'CURRENCY',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'breakEvenPrice',
    metricPath: 'breakEvenPrice',
    label: 'Break Even Price',
    dataType: 'CURRENCY',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'moneyness',
    metricPath: 'moneyness',
    label: 'Moneyness',
    dataType: 'PERCENTAGE',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'bestBid',
    metricPath: 'bestBid',
    label: 'Best Bid',
    dataType: 'CURRENCY',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'bestOffer',
    metricPath: 'bestOffer',
    label: 'Best Offer',
    dataType: 'CURRENCY',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'openInterest',
    metricPath: 'openInterest',
    label: 'Open Interest',
    dataType: 'NUMERIC',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'volume',
    metricPath: 'volume',
    label: 'Volume',
    dataType: 'NUMERIC',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Price and Risk Data',
  },
  {
    key: 'delta',
    metricPath: 'delta',
    label: 'Delta',
    dataType: 'NUMERIC',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Greeks',
  },
  {
    key: 'gamma',
    metricPath: 'gamma',
    label: 'Gamma',
    dataType: 'NUMERIC',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Greeks',
  },
  {
    key: 'theta',
    metricPath: 'theta',
    label: 'Theta',
    dataType: 'NUMERIC',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Greeks',
  },
  {
    key: 'vega',
    metricPath: 'vega',
    label: 'Vega',
    dataType: 'NUMERIC',
    analysisType: 'OPTIONS_PERFORMANCE_SUMMARY',
    category: 'Option Greeks',
  },
] as const satisfies CustomizableMetric[];
